module.exports = __webpack_public_path__ + "img/gamestage.06c9dfa5.png";